<template>
  <div class="table">
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{
        backgroundColor: '#0E59CB',
        color: '#fff',
      }"
      :default-sort="{ prop: 'date', order: 'descending' }"
      ref="singleTable"
      :highlight-selection-row="false"
      :row-class-name="tableRowClassName"
    >
      <el-table-column type="index" label="序号" width="70px" align="center">
      </el-table-column>
      <el-table-column prop="yz" show-overflow-tooltip label="业主">
      </el-table-column>

      <el-table-column prop="yzpf" show-overflow-tooltip label="业主评分">
      </el-table-column>

      <el-table-column prop="nr" show-overflow-tooltip label="内容">
      </el-table-column>
    </el-table>

    <div class="yema">
      <Pagination
        style="margin-top: 10px"
        v-show="query.total > 0"
        :total="query.total"
        :limit.sync="query.pageSize"
        :page.sync="query.pageNum"
        round="false"
        :currentPageSize="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        @pagination="changePage"
      />
    </div>
  </div>
</template>

<script>
import api from "@/api/credit.js";
import wyqyId from "../../config";

export default {
  data() {
    return {
      tableData: [],
      query: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },
    };
  },
  mounted() {
    this.initPage();
  },
  methods: {
    changePage(val) {
      this.query.pageNum = val;
      this.initPage();
    },
    initPage() {
      let params = {
        ...this.query,
        wyqyId: wyqyId,
      };
      api.jkfjlquerylist(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.list;
          this.query.total = res.data.data.total;
        }
      });
    },
    //奇偶行背景色不同
    tableRowClassName({ rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  position: relative;
  height: 410px;
}
.yema {
  position: absolute;
  bottom: -40px;
  right: 0;
}
::v-deep.el-table .warning-row {
  background-color: #0f53a5 !important;
  color: #fff !important;
}

::v-deep.el-table .success-row {
  background-color: #193a5c !important;
  color: #fff !important;
}
::v-deep.el-table tbody tr:hover > td {
  background-color: unset !important;
}
::v-deep.el-table__body {
  border-color: #0f53a5 !important;
}

.el-table {
  border-bottom: 1px solid #1763e8;
  border-right: 1px solid #1763e8;
  border: 1px solid #1763e8;
  margin: 0 auto;
}

::v-deep.el-table th {
  border: 1px solid #1763e8 !important;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep.el-table td {
  border: 1px solid #1763e8;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep .el-table__empty-block {
  background-color: #0e59cb;
}
::v-deep .el-table__empty-text {
  color: #fff;
}
</style>
